import MarketingProductsBanner from './MarketingProductsBanner';

export default MarketingProductsBanner;
